import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "../app/router";
import { Brand } from "./Brand";

const links = [
  { to: "/phong-cach", label: "Nếp xanh" },
  { to: "/thu-vien-cay", label: "Thư viện cây" },
  { to: "/goi-dich-vu", label: "Gói dịch vụ" },
  { to: "/cam-nang", label: "Cẩm nang" },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <>
      <div className="demo-ribbon">
        <span aria-hidden="true">✦</span> Demo hư cấu · Không gửi dữ liệu ra ngoài
      </div>
      <header className="site-header">
        <div className="container header-inner">
          <Brand />
          <nav className={`site-nav ${open ? "is-open" : ""}`} aria-label="Điều hướng chính">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} className={({ isActive }) => (isActive ? "active" : "")}>
                {link.label}
              </NavLink>
            ))}
            <Link className="button button-primary nav-cta" to="/thiet-ke">
              Phác ban công
            </Link>
          </nav>
          <button
            className="icon-button menu-button"
            type="button"
            aria-label={open ? "Đóng menu" : "Mở menu"}
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
          >
            {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
          </button>
        </div>
      </header>
    </>
  );
}
